'use client';

import { CallCalling, FingerScan, Money, PenAdd, ProfileCircle, SecurityCard } from 'iconsax-react';
import Image from 'next/image';
import { useMemo } from 'react';

import { FeatureFlagEnum, useFeatureFlags } from '@shared/featureManagment';
import { TSidebarLink } from '@widgets/sidebar-layout';

const profileSidebarLinks: TSidebarLink[] = [
  {
    id: 'profile-user-info',
    icon: <ProfileCircle size={20} />,
    route: '/profile/user-info',
    label: 'اطلاعات کاربری',
  },
  {
    id: 'profile-contact-info',
    icon: <CallCalling size={20} />,
    route: '/profile/contact-info',
    label: 'اطلاعات تماس',
  },
  {
    id: 'profile-bank-accounts',
    icon: <Money size={20} />,
    route: '/profile/bank-accounts',
    label: 'حساب‌های بانکی',
  },
  {
    id: 'profile-agreement',
    icon: <PenAdd size={20} />,
    route: '/profile/agreement',
    label: 'قراردادها',
  },
  {
    id: 'direct-pay',
    icon: <SecurityCard size={20} />,
    route: '/profile/directpay/managment',
    label: 'پرداخت مستقیم',
  },
  {
    id: 'profile-security',
    icon: <FingerScan size={20} />,
    route: '/profile/security',
    label: 'امنیت',
  },
];
export const useProfileSidebarLinks = () => {
  const featureFlags = useFeatureFlags();

  return useMemo(
    () =>
      profileSidebarLinks.filter(
        (item) =>
          featureFlags.checkFeature(FeatureFlagEnum.directPayEnabled) || item.id !== 'direct-pay'
      ),
    [featureFlags]
  );
};
